import { myFetch, HttpMethod } from './baseService';

export interface EstatusEncomienda {
  een_codigo: string;
  een_nombre: string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

/**
 * Obtener todos los estatus de encomienda
 */
export const obtenerEstatusEncomienda = async () => {
  const envelope = await myFetch<ApiEnvelope<EstatusEncomienda[]>>(
    'estatus_encomienda/ObtenerTodos',
    HttpMethod.POST,
    {}
  );
  return envelope;
};

